import React, { useState } from "react";
import { Button } from "react-bootstrap";
import { useParams } from "react-router-dom";
import Config from "../../_config/config";
import CampaignService from "../../_services/CampaignService";
import TemplateBuilder from "../../components/TemplateBuilder/TemplateBuilder";
import SendTestEmailModal from "./components/SendTestEmailModal";
import "./email-templates.css";

/**
 * Email template editor. Thin wrapper around the shared <TemplateBuilder>:
 * shows the Subject line and the email-specific Send-Test button, and adapts
 * the Message/DesignJson columns via CampaignService.
 */
const EmailTemplateEditorPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const templateId = id === "new" ? null : parseInt(id, 10);
  const [testFor, setTestFor] = useState<{ id: number; name: string } | null>(null);

  return (
    <>
      <TemplateBuilder
        templateId={templateId}
        backPath="/email-templates"
        namePlaceholder="Template name"
        showSubject
        subjectPlaceholder="Email subject line"
        uploadUrl={`${Config.nodeSiteUrl}v1/email-templates/upload-image`}
        editUrl={(newId) => `/email-templates/${newId}/edit`}
        loadTemplate={async (tid) => {
          const res = await CampaignService.getTemplate(tid);
          const data = res.data?.data || {};
          return {
            name: data.Name || "Untitled",
            subject: data.Subject || "",
            html: data.Message || null,
            designJson: data.DesignJson || null,
          };
        }}
        saveTemplate={async ({ id: tid, name, subject, html, designJson }) => {
          const body = { Name: name, Subject: subject, Message: html, DesignJson: designJson };
          if (tid) {
            await CampaignService.updateTemplate(tid, body as any);
            return { id: tid };
          }
          const res = await CampaignService.createTemplate(body as any);
          return { id: res.data?.data?.Id };
        }}
        extraToolbar={({ id: tid, name }) =>
          tid ? (
            <Button variant="secondary" size="sm" onClick={() => setTestFor({ id: tid, name })}>
              Send Test
            </Button>
          ) : null
        }
      />

      {testFor && (
        <SendTestEmailModal
          show
          onHide={() => setTestFor(null)}
          templateId={testFor.id}
          templateName={testFor.name}
        />
      )}
    </>
  );
};

export default EmailTemplateEditorPage;
